module.exports = __webpack_public_path__ + "static/media/ico-chat-white.ea98f288.svg";